module.exports = __webpack_public_path__ + "static/media/34416396_1938192882892776_1260146071821090816_n.09699bce.jpg";